<template>
  <div :class="['card-slider-container',
  {'is-active-focus': idFocusParam},
  `${ theme }-style`,
  { 'is-active-card': isActiveStatic || isActiveFocusParam }]">
    <slot name="top-block"/>
    <div class="line-container">
    </div>
    <div class="active-line-container">
    </div>
    <sub-title @click="$emit('changeId')" class="main-title-container">
      {{ item?.title }}
      <icon-default v-if="item?.icon"
                    :class="{'is-not-active' : !isActiveStatic && !isActiveFocusParam }"
                    :icon="item.icon"/>
    </sub-title>
      <div @click="$emit('actionClick')" :class="['info-container', {
       'is-active': isActiveFocusParam || isActiveStatic
      }]">
        <slot name="bottom-block"/>
      </div>
  </div>
</template>

<script>
import SubTitle from "@/components/shared/text/SubTitle.vue";
import IconDefault from "@/components/shared/IconDefault.vue";

export default {
  name: "CardSlider",
  components: {IconDefault, SubTitle},
  props: {
    idActiveCard: {
      type: Number,
      required: true
    }, 
    idFocusParam: {
      type: [Number, Boolean],
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    theme: {
      type: String,
      default: 'default'
    }
  },
  computed: {
    isActiveStatic() {
      return this.idActiveCard === this.item.id
    },
    isActiveFocusParam() {
      return this.idFocusParam === this.item.id
    },
  },
}
</script>

<style scoped lang="scss">
  .card-slider-container {
    display: flex;
    flex-direction: column;
    position: relative;
    .text-content {
      transition: all .3s ease;
      color: var(--color-dark-purple-grey)
    }
    &.dark-style {
      .text-content {
        color: var(--color-purple-grey)
      }
      .line-container {
        background-color: var(--color-purple-grey);
      }
    }
    &.is-active-card {
      .text-content {
        color: var(--color-white)
      }
      &.dark-style {
        .text-content {
          color: var(--color-purple)
        }
      }
    }

    .icon-container {
      transition: all .3s ease;
      transform: scale(1);
      &.is-not-active {
        transform: scale(0);
        opacity: 0;
      }
    }
    &.is-active-focus {
      .text-content {
        cursor: pointer;
      }
    }
    .text-content {
      display: flex;
      flex-direction: row;
      align-items: center;
    }


    .line-container {
      left: 0;
      top: 0;
      width: 100%;
      background-color: var(--color-dark-purple-grey);
      position: absolute;
    }
    .info-container {
      opacity: 0;
      transform: translateY(-100%);
      transition: all .3s ease;
      pointer-events: none;
      position: relative;
      &.is-active {
        pointer-events: auto;
        transform: translateY(0);
        opacity: 1;
      }
    }
  }

  @media (max-width: 3024px){
    .card-slider-container {
      padding: 20px;
      .main-title-container {
        margin-bottom: 24px;
        column-gap: 16px;
      }
      .line-container {
        height: 1px;
      }
    }
  }

  @media (max-width: 1920px) {
    .card-slider-container {
      padding: 20px;
      .main-title-container {
        margin-bottom: 16px;
      }
      .line-container {
        height: 1px;
      }
    }
  }
  @media (max-width: 1600px) {
    .card-slider-container {
      padding: 14px;
      .main-title-container {
        margin-bottom: 12px;
        column-gap: 16px;
      }
      .line-container {
        height: 1px;
      }
    }
  }
  @media (max-height: 800px) {
    .card-slider-container {
      padding: 12px;
      .main-title-container {
        margin-bottom: 8px;
        column-gap: 8px;
      }
      .line-container {
        height: 1px;
      }
    }
  }

  @media (max-width: 1400px) and (min-height: 801px) {

    .card-slider-container {
      padding: 14px;
      .main-title-container {
        margin-bottom: 12px;
        column-gap: 16px;
      }
      .line-container {
        height: 1px;
      }
    }
  }

  @media (max-width: 1133px) {
    .card-slider-container {
      padding: 12px;
      .main-title-container {
        margin-bottom: 8px;
        column-gap: 8px;
      }

      .line-container {
        height: 1px;
      }
    }
  }
  @media (max-width: 769px) {
    //iPhone 14
  }

  @media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
    //iPhone Plus
  }
  @media (min-height: 600px) and (max-height: 630px){
    //для экранов 8 плюс
  }

  @media (max-width: 375px){
    //iPhone 8
  }


  @media (max-width: 375px) and (min-height: 630px) {
    //iPhone X
  }


  @media (max-width: 320px) {
    //iPhone SE
  }

  @media (min-width: 3025px) {
    .card-slider-container {
      padding: 40px 20px;

      .main-title-container {
        column-gap: 16px;
        margin-bottom: 40px;
      }
      .line-container {
        height: 4px;
      }
    }
  }

</style>